import React from "react";
import "./style.css"
function RrbDropdownUi({
  selectData,
  filtersId,
  applyFilter,
  removeFilter,
  decodedToken,
  showFilter,
}) {
  return (
    <div className="ranodom-select-css-filter">
      <div className="d-flex align-items-end w-100">
        <div class="form-group mb-0 " style={{ minWidth: "200px" }}>
          {/* <label htmlFor="select" className="filters_label">
            {" "}
            Select RRB:
          </label> */}
          <div>
            <select
              id="rrb_id"
              name="rrb_id"
              className="form-control w-100 p-2 select_css select2bs4"
              style={{ width: "100%" }}
              value={filtersId?.rrbId}
            >
              <option value="">Select RRB</option>
              {selectData?.rrb?.map((val) => {
                const id = val?.id;
                return <option value={id}>{val.name}</option>;
              })}
            </select>
          </div>
        </div>
          <button className="common_filters_clear_btn ml-4" style={{height:"40px"}} onClick={removeFilter}>
            Clear
          </button>
      </div>
    </div>
  );
}

export default RrbDropdownUi;
